export var MetricExplorerComparison;
(function (MetricExplorerComparison) {
    MetricExplorerComparison["NONE"] = "none";
    MetricExplorerComparison["PREVIOUS_PERIOD"] = "previous_period";
    MetricExplorerComparison["DIFFERENT_METRIC"] = "different_metric";
})(MetricExplorerComparison || (MetricExplorerComparison = {}));
export var MetricTotalComparisonType;
(function (MetricTotalComparisonType) {
    MetricTotalComparisonType["NONE"] = "none";
    MetricTotalComparisonType["PREVIOUS_PERIOD"] = "previous_period";
})(MetricTotalComparisonType || (MetricTotalComparisonType = {}));
//# sourceMappingURL=metricsExplorer.js.map